module.exports = __webpack_public_path__ + "static/media/24UHCHR1.e579f555.jpg";